import { render, staticRenderFns } from "./ResultRanking.vue?vue&type=template&id=4a5b2020&scoped=true&"
import script from "./ResultRanking.vue?vue&type=script&lang=js&"
export * from "./ResultRanking.vue?vue&type=script&lang=js&"
import style0 from "./ResultRanking.vue?vue&type=style&index=0&id=4a5b2020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b2020",
  null
  
)

export default component.exports